import React, { useEffect } from "react";
import UseContext from "hooks/useContext";
import useFetchData from "hooks/useFetchData";
import SectionWrapper, {
    FormField,
    inputClassName,
    textareaClassName,
} from "pages/createMission/components/SectionWrapper";
import Divider from "components/divider/divider";

const InfoTemplate = () => {
    const { templateData, setTemplateData } = UseContext();
    const { userData } = useFetchData();

    useEffect(() => {
        if (userData?.firstname && userData?.lastname) {
            if (
                templateData.contact_name !== undefined &&
                templateData.contact_name === ""
            ) {
                setTemplateData((prev) => ({
                    ...prev,
                    contact_name:
                        userData.firstname + " " + userData.lastname,
                }));
            }
            if (
                templateData.contact_poste !== undefined &&
                templateData.contact_poste === ""
            ) {
                setTemplateData((prev) => ({
                    ...prev,
                    contact_poste: "Responsable",
                }));
            }
        }
    }, [userData]); // eslint-disable-line

    return (
        <div className="flex flex-col gap-4">
            <SectionWrapper
                title="Responsable"
                description="Indiquez les informations du responsable rattaché à cette fiche."
            >
                <FormField label="Nom complet du responsable">
                    <input
                        name="contact_name"
                        value={templateData.contact_name}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                contact_name: e.target.value,
                            }))
                        }
                        className={inputClassName}
                        type="text"
                        required
                    />
                </FormField>
                <FormField label="Fonction">
                    <input
                        name="contact_poste"
                        value={templateData.contact_poste}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                contact_poste: e.target.value,
                            }))
                        }
                        className={inputClassName}
                        type="text"
                        required
                    />
                </FormField>
            </SectionWrapper>

            <Divider w={100} />

            <SectionWrapper
                title="Informations pour le candidat"
                description="Optionnel · Précisez des éléments utiles pour le candidat retenu (consignes, accès, etc.)."
            >
                <textarea
                    name="other"
                    rows={5}
                    className={textareaClassName}
                    value={templateData.other}
                    maxLength={500}
                    placeholder="Saisissez vos informations…"
                    aria-label="Informations pour le candidat"
                    onChange={(e) =>
                        setTemplateData((prev) => ({
                            ...prev,
                            other: e.target.value,
                        }))
                    }
                />
            </SectionWrapper>

            <Divider w={100} />

            <SectionWrapper
                title="Informations pour l'agence d'intérim"
                description="Optionnel · Notes ou consignes destinées à l'agence Jobbiz."
            >
                <textarea
                    name="other_interim"
                    rows={5}
                    className={textareaClassName}
                    value={templateData.other_interim}
                    maxLength={500}
                    placeholder="Saisissez vos informations…"
                    aria-label="Informations pour l'agence d'intérim"
                    onChange={(e) =>
                        setTemplateData((prev) => ({
                            ...prev,
                            other_interim: e.target.value,
                        }))
                    }
                />
            </SectionWrapper>
        </div>
    );
};

export default InfoTemplate;
